export const selectOptionsHousingEvents = [
  "Deed in lieu",
  "Foreclosure",
  "Forbearance",
  "Short Sales",
  "Lis Pendens",
  "Loan Modifications",
];
